import { getApiCall } from 'api/apiService';
import { GET_ALL_BANNER_AGENT } from 'constant/app.config';
import { useState, useEffect, useCallback } from 'react';

export const useAgentBannerData = (propertyId, isAgentDashboard = false) => {
  const [bannerData, setBannerData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getBannerData = useCallback(async () => {
    const property_Id = isAgentDashboard ? 0 : propertyId;

    setLoading(true);
    setError(null);

    try {
      const response = await getApiCall(
        `${GET_ALL_BANNER_AGENT}/${property_Id}`
      );

      if (response?.status === 200) {
        const data = isAgentDashboard
          ? response?.data
          : response?.data?.[0] || {};
        setBannerData(data);
      } else {
        setError('Failed to fetch banner data');
        console.log('Failed to fetch data');
      }
    } catch (e) {
      setError('An error occurred while fetching data');
      console.error('An error occurred while fetching data:', e);
    } finally {
      setLoading(false);
    }
  }, [propertyId, isAgentDashboard]);

  // Auto fetch when dependency changes
  useEffect(() => {
    if (propertyId !== undefined || isAgentDashboard) {
      getBannerData();
    }
  }, [getBannerData]);

  return {
    bannerData,
    loading,
    error,
    getBannerData, // useful to refresh manually
  };
};
